/**
 * reportCardSettingsApi.js
 * -------------------------
 * Live backend client API for Education > Report Card Settings.
 * Fully compliant with Rule 90 (Zero Mock Data).
 */
import api from '../../../../api/client'

export const DEFAULT_SETTINGS = {
  id: 1,
  header: 'Report Card',
  footer: 'Thank you for choosing our institution',
  gradeA: 90,
  gradeAName: 'Excellent',
  gradeB: 75,
  gradeBName: 'Very Good',
  gradeC: 60,
  gradeCName: 'Good',
  gradeD: 45,
  gradeDName: 'Satisfactory',
  gradeE: 35,
  gradeEName: 'Pass',
  absenteeMarksIncludeExclude: false,
  bodyFields: {
    testNo: true,
    subject: true,
    testDate: true,
    marks: true,
    outOf: true,
    percent: true,
    highest: true,
    grade: true,
    remark: true,
    topic: true,
  },
}

export async function getReportCardSettings() {
  const { data } = await api.get('/education/tests/report-card-settings')
  return {
    ...DEFAULT_SETTINGS,
    ...data,
    bodyFields: {
      ...DEFAULT_SETTINGS.bodyFields,
      ...(data?.bodyFields || {}),
    },
  }
}

export async function updateReportCardSettings(payload) {
  const { data } = await api.put('/education/tests/report-card-settings', payload)
  return data
}
